<template>
    <div>
        <v-container fluid class="pa-5">

            <div class="d-flex align-center py-3">
                <div>
                    <div class="display-1">Create Tainer</div>
                </div>

            </div>
            <v-card>
                <v-toolbar color="grey lighten-4" flat light>
                    <v-spacer/>
                    <v-btn @click="saveTrainer" class="mr-2" color="light-green" dark>Save</v-btn>
                </v-toolbar>
                <v-container fluid>
                    {{trainer}}
                    <TrainerForm
                            ref="form"
                            :trainer="trainer"
                    />
                </v-container>
            </v-card>
        </v-container>

    </div>
</template>

<script>
    import TrainerForm from "../components/Trainer/TrainerForm";
    import TRAINER_CREATE from "../graphql/Trainers/Create.gql";

    export default {
        components: {
            TrainerForm
        },
        metaInfo: {
            title: 'Create Trainer'
        },
        data() {
            return {
                trainer: {
                },
                updating: false,
            }
        },
        methods: {

            saveTrainer() {
                this.$refs.form.validate()

                if(!this.$refs.form.isValid()){
                    return
                }

                this.$apollo.mutate({
                    mutation: TRAINER_CREATE,
                    variables: {input: this.trainer},
                }).then((response) => {
                    this.$emit('complete')
                    this.updating = false
                    this.$emit('saved')
                    this.$store.dispatch('notification/addSuccess', 'Trainer created successful')
                    this.$router.push({ name: 'trainer-view', params: { id: response.data.createTrainer.id } })
                }).catch((error) => {
                    this.$store.dispatch('notification/handleGraphQlError', error)
                })
            }
        },
    }
</script>
